module.exports = __webpack_public_path__ + "static/img/48020.35c0fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48020.jpg
// module id = Wuwo
// module chunks = 1